module.exports = __webpack_public_path__ + "static/img/yszn.7ea3fe85.jpg";